var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C29.5228 24 34 19.5228 34 14C34 8.47715 29.5228 4 24 4C18.4772 4 14 8.47715 14 14C14 19.5228 18.4772 24 24 24Z",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4199 31.48L31.3398 38.5601C31.0598 38.8401 30.7998 39.36 30.7398 39.74L30.3598 42.44C30.2198 43.42 30.8998 44.1 31.8798 43.96L34.5798 43.58C34.9598 43.52 35.4998 43.26 35.7598 42.98L42.8398 35.9001C44.0598 34.6801 44.6398 33.26 42.8398 31.46C41.0598 29.68 39.6399 30.26 38.4199 31.48Z",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 32.5C37.9999 34.66 39.6798 36.3399 41.8398 36.9399",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81982 44C6.81982 36.26 14.5199 30 23.9999 30C26.0799 30 28.0798 30.3 29.9398 30.86",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEditBlack);
export default __webpack_public_path__ + "static/media/user-edit-black.f43993a50f81543d14e897271b957113.svg";
export { ForwardRef as ReactComponent };